import { Modifier, EditorState } from 'draft-js';

import { retrieveEntityTypeByRegex } from '../utils/retrieveEntityTypeByRegex';

export default function addSmartLink(editorState: EditorState, smartLinkData): EditorState {
  const entityType = retrieveEntityTypeByRegex(smartLinkData.urlRegexString);
  const contentStateWithEntity = editorState.getCurrentContent().createEntity(entityType, 'IMMUTABLE', {
    href: smartLinkData.linkHref,
  });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

  const currentSelectionState = editorState.getSelection();

  const linkSelectionText = currentSelectionState.merge({
    anchorOffset: smartLinkData.start,
    focusOffset: smartLinkData.end,
  });

  let smartLinkReplacedContent = Modifier.replaceText(
    editorState.getCurrentContent(),
    linkSelectionText,
    `${smartLinkData.linkHref}`,
    editorState.getCurrentInlineStyle(),
    entityKey
  );

  // // If the link is inserted at the end, a space is appended right after for
  // // a smooth writing experience.
  const blockKey = linkSelectionText.getAnchorKey();
  const blockSize = editorState.getCurrentContent().getBlockForKey(blockKey).getLength();
  if (blockSize === smartLinkData.end) {
    smartLinkReplacedContent = Modifier.insertText(
      smartLinkReplacedContent,
      smartLinkReplacedContent.getSelectionAfter(),
      ' '
    );
  }

  const newEditorState = EditorState.push(editorState, smartLinkReplacedContent, 'insert-fragment');

  return EditorState.forceSelection(newEditorState, newEditorState.getCurrentContent().getSelectionAfter());
}
